import ProductOfferImgWrapper from './ProductOfferImgWrapper';

export default ProductOfferImgWrapper;
